/* 楼盘字典-行政区域 */
<template>
  <div class="body_wapper">
    <div class="warpper_page">
      <div class="warpper_top disFlex" style="justify-content: space-between">
        <h2 class="warpper_top_title">
          区域
        </h2>

        <!-- <a-button-group>
          <a-button type="primary" title="更多" @click="showOpt = !showOpt">
            <a-icon type="edit" />
          </a-button>
          <a-button type="primary" title="新增区域" @click="addHandle">
            <a-icon type="plus" />
          </a-button>
        </a-button-group> -->
      </div>
      <div class="wrapper_search">
        <a-input-search prefix="" placeholder="区域名称" style="width: 200px" @search="searchHandle" />
      </div>
      <div class="disFlex flexWrap list_district">
        <dl
          class="item_district item_record"
          :class="{ cur: index === curIdx }"
          v-for="(item, index) in list"
          :key="item.id"
          @click="selRow(index, item.areaId)"
        >
          <h3 class="item_dis_title" :title="item.areaName">{{ item.areaName }}</h3>
          <div class="item_dis_opts" v-if="showOpt">
            <a-button type="link" :class="{ btn_opt: btnOptShow }" @click.stop="editHandle(item)">
              <a-icon
                type="edit"
                v-if="index === curIdx"
                theme="filled"
                class="borderradius50b"
                :style="btnStyleSel"
              />
              <a-icon type="edit" v-else theme="filled" class="borderradius50b" :style="btnStyle" />
            </a-button>
          </div>
        </dl>
      </div>

      <div class="editModal">
        <a-modal
          :title="formTitle"
          :visible="visible"
          :confirm-loading="confirmLoading"
          ok-text="提交"
          cancel-text="取消"
          @ok="saveHandle"
          @cancel="handleCancel"
        >
          <a-form-model
            ref="dataInfo"
            :model="dataInfo"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item label="区域全称" prop="districtFullName">
              <a-input v-model="dataInfo.districtFullName" allowClear />
            </a-form-model-item>

            <a-form-model-item label="区域简称" prop="districtShortName">
              <a-input v-model="dataInfo.districtShortName" allowClear />
            </a-form-model-item>
          </a-form-model>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // districtList,
 getDistrict, addDistrict, updateDistrict, delDistrict } from '@/api/setting/district'
import { areaList } from '@/api/setting/area'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'District',
  components: {},
  props:
  //  ['disList'],
   {
    disList: {
        type: Array,
        default: () => []
    }
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      curIdx: -1,
      showOpt: false,
      loading: false,
      submitLoading: false,

      btnOptShow: false,
      btnStyle: { fontSize: '14px', color: 'var(--ThemeColor)' },
      btnStyleSel: { fontSize: '14px', color: '#ffffff' },

      visible: false,
      confirmLoading: false,
      formTitle: '操作',

      queryParam: {
        districtFullName: undefined, // 区域全称
        districtShortName: undefined // 区域简称
      },

       queryArea: {
        areaName: undefined, //	名称
        level: undefined, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      },

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      dataInfo: {
        districtFullName: undefined, // 区域全称
        districtShortName: undefined, // 区域简称
        id: undefined // 新增时不传，修改时必传
      },
      rules: {
        districtFullName: [{ required: true, message: '必填', trigger: 'blur' }],
        districtShortName: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      },
      columns: []
    }
  },
  filters: {},
  created () {},
  computed: {},
  watch: {
    disList (val) {
      // console.log(val)
      this.list = val
      if (this.list && this.list.length > 0) {
          this.selRow(0, this.list[0].areaId)
      }
    }
  },
  methods: {
    /** 查询区域信息列表 */
    getList () {
      // this.loading = true
      // districtList(this.queryParam).then((response) => {
      //   if (response.code === 200) {
      //     const resData = response.data
      //     this.disList = resData
      //   }
      //   this.loading = false
      // })
      this.getArea()
    },
    /** **根据系统信息查询区域信息***/
    getArea () {
      this.$parent.getArea()
    },
    addHandle () {
      this.visible = true
      this.formTitle = '新增区域'
      this.resetDataInfo()
    },
    delHandle (row) {
      const that = this
      const districtId = row.areaId
      const name = row.areaName

      that.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中区域【' + name + '】的数据',
        onOk () {
          return delDistrict(districtId).then(() => {
            that.searchHandle('')
            that.$message.success('删除成功', 3)
          })
        },
        onCancel () {}
      })
    },
    editHandle (row) {
      this.visible = true
      const districtId = row.areaId
      const name = row.areaName
      this.formTitle = '修改区域【' + name + '】'

      getDistrict(districtId).then((response) => {
        this.dataInfo = response.data
      })
    },

    searchHandle (value) {
      // this.queryParam.districtFullName = value // 区域全称
      // this.queryParam.districtShortName = value // 区域简称
      // this.$emit('queryNewDistrict', this.queryParam)
      // queryArea: {
      //   areaName: undefined, //	名称
      //   level: undefined, // 等级（1：省 2：市 3：区）
      //   parentId: undefined //	父类ID
      // },
      this.queryArea.areaName = value // 区域名称
      this.queryArea.level = 3 //
      this.$emit('queryNewDistrict', this.queryArea)
    },
    saveHandle () {
      this.confirmLoading = true
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateDistrict(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.visible = false
                this.searchHandle('')
              })
              .finally(() => {
                this.confirmLoading = false
                this.submitLoading = false
              })
          } else {
            addDistrict(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.visible = false
                this.searchHandle('')
              })
              .finally(() => {
                this.confirmLoading = false
                this.submitLoading = false
              })
          }
          this.resetDataInfo()
        } else {
          this.confirmLoading = false
          this.submitLoading = false
          return false
        }
      })
    },
    resetDataInfo () {
      this.dataInfo = {
        districtFullName: undefined, // 区域全称
        districtShortName: undefined, // 区域简称
        id: undefined // 新增时不传，修改时必传
      }
    },

    handleCancel (e) {
      this.visible = false
      this.resetDataInfo()
    },

    selRow (idx, id) {
      this.curIdx = idx
      this.$emit('districtIdEvent', id)
    },
    initParam () {
      // this.queryParam = {
      //   districtFullName: undefined, // 区域全称
      //   districtShortName: undefined // 区域简称
      // }
       this.queryArea = {
        areaName: undefined, //	名称
        level: undefined, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      }
    }
  }
}
</script>

<style scoped>
.warpper_top{
  margin-right:10px;
}

.borderradius50b {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
}
.list_district {
  flex-direction: column;
  margin-top: 20px;
}

.btn_opt {
  margin-right: 5px;
}

.item_dis_title {
  margin: 0px;
}
.cur .item_dis_title
/* ,.item_district:hover .item_dis_title */ {
  color: #fff;
  font-weight: bold;
}
.item_dis_opts {
  display: flex;
}
.ant-form-item {
  width: 100%;
}
.item_record {
  height: 40px;
  display: block;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 96%;
  padding: 0px 2%;
  cursor: pointer;
  font-size: 14px;
}
</style>
